import { createColumnHelper } from "@tanstack/react-table"
import DataTable from "../../../../components/dataTable/DataTable";
import dayjs from "dayjs";
import { ApiEndpoints } from "../../../../config/apiClient";

const URL_BASE = `${ApiEndpoints.apiOld}/dashboard/despesas/todos_relatorios?`
export default function DespesasTabelaPesquisa({ data, filtros }:iPropsTable) {

    function tableMiddleClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"))
        const reg = data[idx]
        const link = `${URL_BASE}id_relatorio=${reg.id_relatorio.id_relatorio}`
        if (event.button === 1) {
            window.open(link)
        }
    }
    function tableClickhandler(event: any) {
        // const idx = Number(event.target.parentElement.getAttribute("about"))
        // const reg = data[idx]
        // const link = `${URL_BASE}id_relatorio=${reg.id_relatorio.id_relatorio}`
        // window.open(link)
    }
    function handleData() {
        const MONEY_FORMATTER = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
        let despesasAux: iDespesaDto[] = []
        let usuarios: any[] = []
        if (Object.values(filtros).length > 0) {
            usuarios = filtros.usuarios
        }
        for (let despesa of data) {
            // despesa.data_criacao = `${dayjs(despesa.data_criacao).format("DD/MM/YYYY HH:mm:ss")}`

            if (usuarios.length > 0) {
                const ID_COLABORADOR = despesa.id_relatorio.id_colaborador
                const COLS = usuarios.filter(reg => reg.id_colaborador === ID_COLABORADOR)
                if (COLS.length > 0) {
                    const COLABORADOR = COLS[0]
                    despesa.usuario = `${COLABORADOR.nome}`
                }
            }

            const DATA_DESPESA = despesa.data_pagamento !== null ? dayjs(despesa.data_pagamento).format("DD/MM/YYYY") : dayjs(despesa.data_despesa).format("DD/MM/YYYY")
            despesa.data_pagamento_aux = DATA_DESPESA

            despesa.valor_aux = MONEY_FORMATTER.format(Number(despesa.valor))
            
            const DATA_VENCIMENTO = despesa.data_vencimento === null ? "" : dayjs(despesa.data_vencimento).format("DD/MM/YYYY")
            despesa.data_vencimento_aux = DATA_VENCIMENTO
            
            let num_cartao: string = despesa.id_cartao === null ? "" : String(despesa.id_cartao.num_cartao)
            num_cartao = num_cartao.substring(num_cartao.length - 4)
            const CARTAO = despesa.id_cartao === null ? "" : `${despesa.id_cartao.nome_portador} ${num_cartao}`
            if (despesa.id_cartao !== null) { despesa.cartao = CARTAO } else { despesa.cartao = "" }
            
            despesasAux.push(despesa)
        }
        return despesasAux
    }
    
    return (
        <div id="graph_table" className="graph_backgrounds" style={{ width: "100%", margin: "10px 0px 10px 0px" }}>
            <DataTable
                dados={handleData()}
                tableSize={"auto"}
                defaultColumns={defaultColumns}
                tableMiddleClickhandler={tableMiddleClickhandler}
                tableClickhandler={tableClickhandler}
                defaultOrder={defaultOrder}
            />
        </div>
    )
}
interface iPropsTable {
    data: iDespesaDto[]
    filtros: any
}

export interface iDespesaDto {
    id_despesa: number
    id_relatorio: any
    usuario: string
    id_empresa: any
    id_cliente: any
    id_centro_custo: number
    data_despesa: string
    data_pagamento: string
    data_pagamento_aux: string
    data_criacao: string
    data_dia: string
    descricao: string
    id_moeda: number
    valor: string
    valor_aux: string
    id_forma_pagamento: any
    data_vencimento: string
    data_vencimento_aux: string
    id_cartao: any
    cartao: string
    id_categoria: any
    id_veiculo: number
    veiculo_km: string
    veiculo_litros: string
    parcelado: number
    qtd_parcelas: number
    valor_parcela: string
    dividida: number
    contabilizado: number
    data_contabilizado: string
    id_despesa_base: number
}

const columnHelper = createColumnHelper<iDespesaDto>();

const defaultColumns = [
    columnHelper.accessor(row => dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss"), {
        header: "Data Criação",
        // size: 250,
    }),
    columnHelper.accessor(row => row.id_empresa.nome, {
        header: "Empresa",
        // size: 150,
    }),
    columnHelper.accessor("usuario", {
        header: "Usuário",
        // size: 150,
    }),
    columnHelper.accessor("data_pagamento_aux", {
        header: "Data Pagamento",
        // size: 150,
    }),
    columnHelper.accessor("valor_aux", {
        header: "Valor",
        // size: 150,
    }),
    columnHelper.accessor("descricao", {
        header: "Descrição",
        // size: 150,
    }),
    columnHelper.accessor(row => row.id_forma_pagamento.descricao, {
        header: "Forma Pagamento",
        // size: 150,
    }),
    columnHelper.accessor("data_vencimento_aux", {
        header: "Vencimento",
        // size: 150,
    }),
    columnHelper.accessor(row => row.id_categoria.descricao, {
        header: "Categoria",
        // size: 150,
    }),
    columnHelper.accessor(row => row.id_cliente.descricao, {
        header: "Cliente",
        // size: 150,
    }),
    columnHelper.accessor("cartao", {
        header: "Cartão Corporativo",
        // size: 150,
    }),
    columnHelper.accessor(row => `RT-${row.id_relatorio.id_relatorio}`, {
        header: "Relatório",
        // size: 150,
    }),
];

const defaultOrder = [
  {
    id: "data_criacao",
    desc: true,
  },
];